<template>
  <div class="advantage">
    <div class="header">
      <div class="title">方案优势</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in advantageList" :key="item.id">
          <div class="right">
            <img :src="item.logo" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import advantage1 from "../../../../assets/programme/advantage1.png";
import advantage2 from "../../../../assets/programme/advantage2.png";
import advantage3 from "../../../../assets/programme/advantage3.png";
import advantage4 from "../../../../assets/programme/advantage4.png";
import advantage5 from "../../../../assets/programme/advantage5.png";
import advantage6 from "../../../../assets/programme/advantage6.png";

export default {
  setup() {
    return reactive({
      advantageList: [
        {
          id: 1,
          title: "安全防控",
          text: "与智能监控系统链接使用，提高安防质量，减少安全隐患",
          logo: advantage1,
        },
        {
          id: 2,
          title: "AI智能算法",
          text: "AI智能平台整合了AI推理所需的各类应用功能，形成AI算法仓库，实现AI应用能力的统一管理",
          logo: advantage2,
        },
        {
          id: 3,
          title: "灵活便捷",
          text: "提供多种智能接口，与物业系统融合，提高物业管理效率。",
          logo: advantage3,
        },
        {
          id: 4,
          title: "安装方便",
          text: "结构设计合理易安装，材料坚固，安全系数高，改造成本低",
          logo: advantage4,
        },
        {
          id: 5,
          title: "降低成本",
          text: "支持人脸、身份证、IC卡、密码、二维码等多种识别方式，并支持多种组合识别鉴权方式",
          logo: advantage5,
        },
        {
          id: 6,
          title: "出入记录自动保存",
          text: "储存空间大，出入记录自动保存，可在线查看访客记录。",
          logo: advantage6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.advantage {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.body .list .item {
  width: 162px;
  display: flex;
  margin-bottom: 40px;
  text-align: center;
}
.body .list .item .right img {
  width: 36px;
}
.body .list .item .right .title {
  font-size: 14px;
  margin-top: 12px;
  font-weight: 600;
}
.body .list .item .right .text {
  font-size: 12px;
  margin-top: 8px;
  color: #495a6c;
}
</style>
